import {
  UseQueryResult,
  UseQueryOptions,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query';

export const AppUpgradeConfirmationKey = ['show-app-upgrade-confirmation'];

export const useAppUpgradeConfirmationQuery = (
  queryOptions: UseQueryOptions<
    boolean,
    unknown,
    boolean,
    typeof AppUpgradeConfirmationKey
  > = {},
): UseQueryResult<boolean> => {
  const queryClient = useQueryClient();
  const value =
    queryClient.getQueryData<boolean>(AppUpgradeConfirmationKey) ?? false;

  return useQuery(AppUpgradeConfirmationKey, () => value, {
    ...queryOptions,
  });
};
